export default "__VITE_ASSET__9HoWOCdH__"